import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AggregatorCardBox from 'components/aggregator/aggregatorBoxes/aggregatorCardBox/aggregatorCardBox';
import { AggregatorGenericView } from './aggregatorGenericView/aggregatorGenericView';

import { CARDS } from 'constants/aggregator/products';
import { NOT_ALLOWED_TINK_AGGREGATOR } from 'constants/flagBasedFeatures';

class AggregatorCardsViewClass extends React.PureComponent {
  getProductComponent(product, isTinkAggregator, onExpand) {
    const id = product.get('id');
    const number = product.get('number');
    const type = product.get('type');
    const alias = product.get('alias');
    const disposed = product.get('disposed');
    const available = product.get('available');
    const limitCredit = product.get('limitCredit');
    const expired = product.get('expired');
    const expirationDate = product.get('expirationDate');
    const lastUpdate = product.get('lastUpdate');
    const details = product.get('details');
    const brandCard = product.get('brandCard');
    const active = product.get('active');

    return (
      product && (
        <AggregatorCardBox
          number={number}
          id={id}
          active={active}
          type={type}
          alias={alias}
          disposed={disposed}
          available={available}
          limitCredit={limitCredit}
          expired={expired}
          expirationDate={expirationDate}
          lastUpdate={lastUpdate}
          details={details}
          brandCard={brandCard}
          isTinkAggregator={isTinkAggregator}
          onExpand={onExpand}
        />
      )
    );
  }

  render() {
    const { immFlagBasedFeatures } = this.props;

    const isTinkAggregator = immFlagBasedFeatures.get(NOT_ALLOWED_TINK_AGGREGATOR);

    return (
      <AggregatorGenericView
        hasDetails={true}
        productType={CARDS}
        getProductComponent={this.getProductComponent}
        isTinkAggregator={isTinkAggregator}
      />
    );
  }
}

AggregatorCardsViewClass.propTypes = {
  immFlagBasedFeatures: PropTypes.object,
};

AggregatorCardsViewClass.defaultProps = {
  immFlagBasedFeatures: {},
};

const AggregatorCardsView = connect(state => {
  return {
    immFlagBasedFeatures: state.flagBasedFeatures,
  };
})(AggregatorCardsViewClass);

export { AggregatorCardsView };
